import {
  ADMIN_INCOMING_ORDER_STATUSES,
  CUSTOMER_ACTIVE_ORDER_STATUSES,
  ORDER_STATUSES,
  TERMINAL_ORDER_STATUSES,
  type OrderStatus,
} from '../types/order';

/** F-005 Decision R2: page size for the storefront home product grid.
 *  Fits cleanly in every grid breakpoint (2/3/4 cols → 6/4/3 rows).
 *  A V1 A/B test can change page size in one place. */
export const STOREFRONT_PRODUCT_PAGE_SIZE = 12;

/** F-019 Decision 2: 20 orders per page for the customer order history list. */
export const ORDER_HISTORY_PAGE_SIZE = 20;

/** F-020: poll interval for the customer order detail page (60 seconds). */
export const ORDER_POLL_INTERVAL_MS = 60_000;

/** F-021: 20 orders per page for the merchant order list. Same value as
 *  ORDER_HISTORY_PAGE_SIZE but distinct name for semantic clarity. */
export const ADMIN_ORDERS_PAGE_SIZE = 20;

export {
  ORDER_STATUSES,
  CUSTOMER_ACTIVE_ORDER_STATUSES,
  ADMIN_INCOMING_ORDER_STATUSES,
  TERMINAL_ORDER_STATUSES,
};

/**
 * F-020: statuses from which an order can never transition further.
 * `refetchInterval` returns `false` for these to stop polling.
 */
export const TERMINAL_STATUSES = new Set<OrderStatus>(TERMINAL_ORDER_STATUSES);

/** F-006 D8: inventory threshold for the "Low stock — only N left"
 *  availability tier on the product detail page. A product with
 *  `0 < inventory <= LOW_STOCK_THRESHOLD` shows the low-stock pill;
 *  `inventory > LOW_STOCK_THRESHOLD` shows the generic "In stock" pill
 *  without disclosing the raw count. `inventory === 0` shows the
 *  "Out of stock" badge and swaps the Contact-seller CTA. Pinned in
 *  shared constants so a future feature changes the cutoff in one place. */
export const LOW_STOCK_THRESHOLD = 5;
